import React from 'react';
import * as ROUTES from '../constants/routes';

import "./menuPrincipal.css";

function MenuPrincipal() {
    return (
        <nav className="navbar navbar-expand-lg navbar-light fixed-top py-3 fundoBranco" id="mainNav">
            <div className="container">
                <a className="navbar-brand js-scroll-trigger text-verde" href="/">eXpert Serviços</a>
                <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarResponsive">
                    <ul className="navbar-nav ml-auto my-2 my-lg-0">
                        <li className="nav-item">
                            <a className="nav-link js-scroll-trigger" href="/">Construção</a>
                        </li>
                        <li className="nav-item">
                           <a className="nav-link js-scroll-trigger" href="/">Reforma</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link js-scroll-trigger" href="/">Fiação elétrica</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link js-scroll-trigger" href="/">Serviços hidráulicos</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link js-scroll-trigger" href="/">Pintura</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link js-scroll-trigger destaque" href={ROUTES.SIGN_IN}>Solicite um Orçamento</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default MenuPrincipal;